import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTheme } from '@material-ui/styles';
import NavList from './NavContainer/NavList';
import ActionButton from './NavContainer/ActionButton';

export function NavContainerImpl({ logo, theme, onNavItem }) {
  return (
    <div style={{ width: '250px', cursor: 'pointer', float: 'left' }}>
      <div style={{ backgroundColor: theme.palette.logoBGColor, display: 'flex' }}>
        <img src={logo} className="imglogo" alt="logo" style={{ width: 190, height: 83 }} />
        <ActionButton />
      </div>
      <NavList onNavItem={onNavItem} />
    </div>
  );
}

const navContainerPropTypes = {
  logo: PropTypes.string.isRequired,
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      logoBGColor: PropTypes.string,
    }),
  }).isRequired,
  onNavItem: PropTypes.func.isRequired,
};

export { navContainerPropTypes };

NavContainerImpl.propTypes = navContainerPropTypes;

export function mapStateToProps(state) {
  return {
    logo: state.brand.brand.logo,
  };
}

export default connect(mapStateToProps)(withTheme(NavContainerImpl));
